import { render, staticRenderFns } from "./GuidPocket.vue?vue&type=template&id=2ea04f2c&scoped=true"
import script from "./GuidPocket.vue?vue&type=script&lang=js"
export * from "./GuidPocket.vue?vue&type=script&lang=js"
import style0 from "./GuidPocket.vue?vue&type=style&index=0&id=2ea04f2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea04f2c",
  null
  
)

export default component.exports